import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function ReloadButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Reload Data
    </Button>
  );
}
